<template>
  <div class="page" :style="{height: windowHeight + 'px'}" data-flex="dir:top main:center cross:center">
    <Button type="info" class="btn nmt" data-flex-box="0" @click="testGlobalLoading">
      全局 loading 测试
    </Button>
    <Button type="info" class="btn" data-flex-box="0" @click="testGlobalAlert">
      全局 alert 弹窗测试
    </Button>
    <Button type="info" class="btn" data-flex-box="0" @click="testGlobalConfirm">
      全局 confirm 弹窗测试
    </Button>
    <Button type="info" class="btn" data-flex-box="0" @click="kb1.show = true">
      显示 vant 数字键盘组件
    </Button>
    <Button type="info" class="btn" data-flex-box="0" @click="$refs.popup1.open()">
      全局 popup 组件测试
    </Button>
    <Button type="info" class="btn" :to="{name: 'MyOrderList', query: {filterType: 1}}">
      我的订单页面
    </Button>
    <p class="lnk" data-flex-box="0" data-flex="main:center">
      <router-link :to="{name: 'MyOrderList', query: {filterType: 1}}" data-flex-box="0">
        页面跳转 router-link
      </router-link>
    </p>
    <NumberKeyboard :show="kb1.show" @blur="kb1.show = false" />
    <MgPopup ref="popup1" direction="bottom" :height="400">
      <div style="height: 100%;" data-flex="main:center cross:center">
        <p data-flex-box="0">弹窗1的内容</p>
      </div>
    </MgPopup>
  </div>
</template>

<script>
import mix1 from '@/mixins/page'
import {uiShowLoading, uiHideLoading, uiAlert, uiConfirm} from '@/utils/ui'
import {delayAsync} from '@/utils/common'
import {Button, NumberKeyboard} from 'vant'
import MgPopup from '@/components/common/mg-popup'

export default {
  mixins: [mix1],
  components: {MgPopup, Button, NumberKeyboard},
  data() {
    return {
      kb1: {
        show: false
      }
    }
  },
  methods: {
    async testGlobalLoading() {
      uiShowLoading()
      await delayAsync(5000)
      uiHideLoading()
    },
    testGlobalAlert() {
      uiAlert('全局 alert 弹窗测试', () => console.log('点击了全局 alert 弹窗的按钮'))
    },
    testGlobalConfirm() {
      uiConfirm(
        '全局 confirm 弹窗测试',
        () => console.log('点击了全局 confirm 弹窗的确定按钮'),
        () => console.log('点击了全局 confirm 弹窗的取消按钮')
      )
    }
  }
}
</script>

<style lang="less" scoped>
.page {
  .btn, .lnk {
    width: 690px;
    margin-top: 20px;

    &.nmt {
      margin-top: 0;
    }

    a {
      color: #1E9FFF;
      text-decoration: none;

      &:hover {
        color: #1E9FFF;
      }
    }
  }
}
</style>